import { render, staticRenderFns } from "./localProductThreshold.vue?vue&type=template&id=6473e88c&scoped=true"
import script from "./localProductThreshold.vue?vue&type=script&lang=js"
export * from "./localProductThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473e88c",
  null
  
)

export default component.exports